/**
 * Created by: cparaschiv
 * Date: 13.08.2013, 16:04
 */

TS.ns('TS.UI');

(function(window, undefined) {
    'use strict';

    //see http://fortawesome.github.io/Font-Awesome/icons/
    TS.UI.defaultIcons = {
        Save: 'save',
        Close: 'remove-sign',
        Add: 'plus',
        Edit: 'edit',
        Delete: 'remove',
        AddRoot: 'plus-sign',
        Expand: 'expand-alt',
        Collapse: 'collapse-alt'
    }
})(this);

